import { defineStore } from "pinia";
import { mande } from "mande";
import { isPastEvent } from "@/ts/utils/event-utils";

export interface CalendarEvent {
    /*
    name: string;
    slug: string;
    description?: string;
    media: {
        cover: {
            src: string;
            is_poster: 0 | 1;
        };
        img: Array<string>;
    };
    client: string;
    tickets: {
        regular: {
            name: string;
            slug: string;
            img: string;
            price: number;
        };
        member: {
            name: string;
            slug: string;
            img: string;
            price: number;
        };
    };
    max_tickets: string;
    sold_tickets: string;
    endsale: string;
    archived: string;
    spotlight: string;
    dates: Array<{
        date: string;
        start: string;
        doors: string;
    }>;
    location: {
        name: string;
        street: string;
        nr: string;
        postal: string;
        city: string;
    };
    categories: Array<string>;
    url: string;*/

    id: number;
    slug: string;
    status: string;
    datemonth: string;
    title: {
        rendered: string;
    };
    categories: number[] | null;
    categories_names: string[];
    //categories_objects: { id: number; name: string; slug: string }[] | null;
    post_name: string;
    post_title: string;
    acf: {
        description: string;
        media: {
            thumbnail: ACFImage;
            is_poster: boolean;
            media_source: string;
            flickr_album_id: string;
            gallery?: ACFImage[] | null;
        };
        info: {
            dates: {
                date: string;
                doors: string;
                start: string;
                end: string;
            }[];
            location: {
                address: string;
                lat: number;
                lng: number;
                zoom: number;
                place_id: string;
                name: string;
                street_number: string;
                street_name: string;
                city: string;
                state: string;
                state_short: string;
                post_code: string;
                country: string;
                country_short: string;
            };
            event_type: "only_registrations" | "registration_and_payment" | "no_registrations" | "external_ticketing";
            external_ticketing_url: string;
            registration_limit: string;
            registrations_open: boolean;
            pricing?:
                | {
                      group: string;
                      price: string;
                  }[]
                | null;
            price_description?: string;
            event_label?: string;
            confirmation_email: string;
        };
    };
}

export interface CalendarEventCategory {
    id: number;
    slug: string;
    name: string;
    count: number;
}

export interface CalendarEventFilter {
    categories?: number[];
    archived?: boolean;
    search?: string;
    months?: string[];
    page?: number;
}

const api = mande("/api");
const json = mande("/json");

export const useEventStore = defineStore("event", {
    state: () => {
        return {
            all: [],
            categories: [],
            months: [],
            viewing: undefined,
        } as { all: CalendarEvent[]; categories: CalendarEventCategory[]; months: string[]; viewing?: number };
    },

    actions: {
        async indexEvents(eventFilter?: CalendarEventFilter): Promise<CalendarEvent[]> {
            const events = await api.get<{ status: number; data: CalendarEvent[] }>("events", eventFilter ? { query: eventFilter } : undefined);

            if (events.status === 200) {
                if (eventFilter && eventFilter.archived === true) {
                    events.data = events.data.filter((event: CalendarEvent) => isPastEvent(event));
                } else {
                    events.data = events.data.filter((event: CalendarEvent) => !isPastEvent(event));
                }
                if (eventFilter && eventFilter.page && eventFilter.page > 1) {
                    this.all.push(...events.data);
                } else {
                    this.all = events.data;
                }
            }

            /*
            let events = await json.get<CalendarEvent[]>("events.json");

            if (eventFilter && eventFilter.archived === true) {
                events = events.filter((event: CalendarEvent) => isPastEvent(event));
            } else {
                events = events.filter((event: CalendarEvent) => !isPastEvent(event));
            }

            this.all = events;*/

            return this.all;
        },

        async indexCategories(archived: boolean): Promise<CalendarEventCategory[]> {
            const categories = await api.get<CalendarEventCategory[]>("categories", { query: { archived: archived } });

            this.categories = categories;

            return this.categories;
        },

        async indexMonths(archived: boolean): Promise<string[]> {
            const months = await api.get<{ status: number; data: string[] }>("eventmonths", { query: { archived: archived } });

            if (months.status === 200) {
                this.months = months.data;
            }

            return this.months;
        },
    },
});
